module.exports = __webpack_public_path__ + "static/img/1.212edae.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/10/1.png
// module id = FSfE
// module chunks = 0